<template>
  <v-container
    class="border mt-8"
    data-testId="invoice-editor-attendance-logs"
  >
    <v-row
      v-for="(log, index) in attendanceLogData"
      :key="index"
      :class="
        index !== attendanceLogData.length + questions.length - 1 ? 'border-b-sm fs-16' : 'fs-16'
      "
    >
      <v-col>
        <strong>{{ $bct(log.label) }}</strong>
      </v-col>
      <v-col>{{ log.value }}</v-col>
    </v-row>

    <v-row
      v-for="(question, index) in questions"
      :key="question.id"
      :class="index !== questions.length - 1 ? 'border-b-sm fs-16' : 'fs-16'"
    >
      <v-col>
        <strong>{{ $bct(question.title) }}</strong>
      </v-col>
      <v-col>
        {{ attendanceLog.custom[question.synced_attributes[0]?.name?.split('.')?.[1]] }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { formatDate } from '@/shared/services/date-helper';
import useApi from '@/shared/composables/useApi';

const $bct = inject('translator');
const { api: Api } = useApi();

const props = defineProps({
  attendanceLog: {
    type: Object,
    required: true,
  },
  subsidyProgramId: {
    type: String,
    required: true,
  },
});

const programName = ref(null);
const attendanceLogQuestions = ref([]);
onMounted(load);

const questions = computed(() => attendanceLogQuestions.value);

const attendanceLogData = computed(() => {
  const monthOfCare = formatDate(
    `${props.attendanceLog.year}-${props.attendanceLog.month}`,
    'MMM-yyyy',
    { parseFormat: 'yyyy-MM' },
  );
  const submittedAt = formatDate(props.attendanceLog.submitted_at, "yyyy-MM-dd 'at' h:mm a");
  return [
    {
      label: 'Submitted',
      value: submittedAt,
    },
    { label: 'Program', value: programName.value },
    { label: 'Month of care', value: monthOfCare },
    { label: 'Start date', value: props.attendanceLog.meta?.enrollment?.start_date },
    { label: 'End date', value: props.attendanceLog.meta?.enrollment?.end_date },
  ];
});

async function load() {
  const programResponse = await Api.publicApi.organization.program.get(
    props.attendanceLog.program_id,
  );
  programName.value = programResponse?.data?.name;

  const attendanceLogQuestionsResponse = await Api.shared.questionSet.index({
    owner_id: props.attendanceLog.schema_id,
    owner_type: 'Schema',
  });

  if (attendanceLogQuestionsResponse?.data) {
    attendanceLogQuestions.value = attendanceLogQuestionsResponse.data;
  }
}
</script>
